import getInstance from "../config/api";

export default class Log {
  static async fetchDetailsLogs(id) {
    const instance = getInstance();
    const { data } = await instance.get(`/log/${id}`);
    return data;
  }
}
